import { dreamKeyboardEvents } from "source/app/services/UI/KeyboardEvents/Global/Dreams/DreamKeyboardEvents";
import {
    globalKeyboardEvents,
} from "source/app/services/UI/KeyboardEvents/Global/GlobalKeyboardEvents";
import { AttachKeyboardEvents } from "source/app/services/UI/KeyboardEvents/Global/AttachKeyboardEvents";
import { workflowsKeyboardEvents } from "source/app/services/UI/KeyboardEvents/Global/workflowsKeyboardEvents";
import DesktopDevice from "./DesktopDevice";
import { IsMobileDevice } from "./Helpers/IsMobile";
import IDevice from "./IDevice";
import MobileDevice from "./MobileDevice";

class Device {
    private _device: IDevice;

    public Initialize() {
        this._device.Initialize();
        AttachKeyboardEvents(workflowsKeyboardEvents);
        AttachKeyboardEvents(globalKeyboardEvents);
        AttachKeyboardEvents(dreamKeyboardEvents);
    }

    public get DebounceTime(): number {
        return 400;
    }

    constructor() {
        this._device = IsMobileDevice()
            ? new MobileDevice()
            : new DesktopDevice();
    }
}

export default new Device();
